import React, { useState, useEffect } from "react";

interface ResendOtpProps {
  onResend: () => void;
  initialSeconds?: number;
}

const ResendOtp: React.FC<ResendOtpProps> = ({
  onResend,
  initialSeconds = 120,
}) => {
  const [seconds, setSeconds] = useState<number>(initialSeconds);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
  const [isResendDisabled, setIsResendDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (seconds > 0) {
      const intervalId = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);

      return () => clearInterval(intervalId);
    } else {
      setIsButtonDisabled(false);
    }
  }, [seconds]);

  const handleResend = () => {
    onResend();
    setIsResendDisabled(true);
  };

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return (
    <div className="flex justify-between items-center mt-5">
      <span>Didn't get the OTP?</span>
      <span>
        <button
          onClick={
            !isButtonDisabled && !isResendDisabled ? handleResend : undefined
          }
          className={`px-3 py-1 rounded-md bg-orange text-white ${
            (isButtonDisabled || isResendDisabled) &&
            "opacity-50 cursor-not-allowed"
          }`}
        >
          {isResendDisabled
            ? "Resend"
            : seconds !== 0
            ? `Resend in ${formatTime(seconds)}`
            : "Resend"}
        </button>
      </span>
    </div>
  );
};

export default ResendOtp;
